import { useIsDarkMode } from "store/atoms";
import { NetworkResourcesType } from "./useDebuggerGroups";
import { darkModeTextColor } from "constants/colors";
import styled, { css } from "styled-components/macro";
import { NetworkItemRow } from "./NetworkItemRow";
import { useDebuggerPopupState } from "../debuggerUtils";

export const ControlGroupContent = ({
  isDefault,
  items,
  dataRequiredOnThisPage,
}: {
  isDefault: boolean;
  items: NetworkResourcesType;
  dataRequiredOnThisPage: string[];
}) => {
  const [isDarkMode] = useIsDarkMode();
  const [{ popupData }] = useDebuggerPopupState();

  return (
    <Container $bg={isDefault} $isDarkMode={isDarkMode}>
      {Object.entries(items).map(
        ([
          networkName,
          {
            isNetworkOnline,
            data,
            timesUpdated,
            itemCounts,
            serverName,
            graphiqlUrlOrUrls,
          },
        ]: any) => {
          return (
            <NetworkItemRow
              key={networkName}
              {...{
                networkName,
                isNetworkOnline,
                data,
                timesUpdated,
                itemCounts,
                serverName,
                graphiqlUrlOrUrls,
                isDataRequiredOnThisPage:
                  dataRequiredOnThisPage.includes(serverName),
                isSelected: networkName === popupData?.networkName,
              }}
            />
          );
        }
      )}
    </Container>
  );
};

const Container = styled.div<{
  $bg: boolean;
  $isDarkMode: boolean;
}>`
  background: ${props => (props.$bg ? "#f9f9f9" : "#fff")};
  ${({ $isDarkMode }) =>
    $isDarkMode
      ? css`
          background: none;
          color: ${darkModeTextColor};
        `
      : ""}
  padding: 16px;
  margin-bottom: 8px;
`;
